<template>
    <div>
        <el-dialog v-el-drag-dialog :title="'转督办任务'" :append-to-body="true" :visible.sync="dialogFormVisible" width="80%">
            <div class="dialog-body">
                <div v-if="listdata.length > 0" class="table-inner">
                    <el-table class="record-table" :data="listdata" border style="width: 100%">
                        <el-table-column width="55" :label="'序号'" align="center" type="index" />
                        <el-table-column :label="'会议议题'" align="left" prop="subject" />
                        <el-table-column :label="'承办部门'" width="150" align="center" prop="mainDept" />
                        <el-table-column :label="'陈述人'" width="100" align="center" prop="reportPersonName" />
                        <el-table-column :label="'决策建议'" width="200" align="left" prop="resolution" />
                        <el-table-column :label="'督办状态'" width="100" align="center">
                            <template slot-scope="scope">
                                <span>{{ dcdbStatusOption(scope.row.dcdbStatus) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column :label="'附件'" align="center" width="100" prop="smsContent">
                            <template slot-scope="scope">
                                <span>{{ scope.row.passenger.attachCount }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column :label="'操作'" align="center" width="100" prop="smsContent">
                            <template slot-scope="scope">
                                <el-link @click="choose(scope.row)">选择</el-link>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button v-pageBtn-lbl="'cancel'" :icon="'el-icon-close'" @click="closeE">关 闭</el-button>
            </span>
        </el-dialog>
        <Basicform v-if="showBasicForm" ref="Basicform" :title="title" :win-width="moduleInfo.winWidth" :win-height="moduleInfo.winHeight" :append-to-body="true" :toolbar-btns="busiformBtns" :on-basic-form-opened="onBasicFormOpened" :on-basic-form-before-submit="onBasicFormBeforeSubmit" :on-basic-form-submited="onBasicFormSubmited">
            <template #default="slotProps">
                <BusiForm ref="busiForm" :vo="slotProps.vo" :can-edit="slotProps.canEdit" :module-info="moduleInfo" />
            </template>
        </Basicform>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
        return {
            listdata: [],
            dialogFormVisible: false,
            showBasicForm: false,
            busiformBtns: [
                { id: 'btn_close', btnName: '关 闭', btnIcon: 'close', btnClick: 'closeDialog', btnPermission: '', btnType: '' },
                { id: 'btn_save', btnName: '保 存', btnIcon: 'check', btnClick: this.submit, btnPermission: 'saveObject', btnType: 'primary' },
                { id: 'btn_save', btnName: '下一个', btnIcon: 'check', btnClick: this.submitBusiform, btnPermission: '', btnType: 'primary' }
            ],
            moduleInfo: {
                winWidth: 1000,
                delUrl: '/dcdb/task/delete',
                addNewUrl: '/dcdb/task/addNew',
                insertUrl: '/dcdb/task/insert',
                moduleCode: 'task',
                winHeight: 600,
                updateUrl: '/dcdb/task/update',
                listDataUrl: '/dcdb/task/listdata',
                getByIdUrl: '/dcdb/task/getById'
            },
            row: {}
        }
    },
    computed: {},
    watch: {},
    created() {
        this.$bus.on('taskDiaShow', this.open)
    },
    beforeDestroy() {
        this.$bus.off('taskDiaShow', this.open)
    },
    mounted() {},
    methods: {
        choose(row) {
            this.row = row
            const _this = this
            _this.showBasicForm = true
            _this.moduleInfo.row = row
            _this.moduleInfo.formTemplate = `#/dcontent/vuebusiform/W/dcdb.task.form_toChange.vue?sysCode=${row.orgCode}_ecydcdb`
            _this.title = '转督办任务'
            _this.$options.components['BusiForm'] = _this.$loadComponent(_this.moduleInfo.formTemplate)
            _this.$nextTick(() => {
                _this.$bus.emit('openBusiform', _this.moduleInfo, null, 1, (res) => {
                    if (res.code === 'success') {
                        _this.showBasicForm = false
                        _this.$message({ type: 'success', message: '保存成功!' })
                        setTimeout(() => {
                            _this.open(_this.listdata)
                        }, 1000)
                    }
                })
            })
        },
        submit(val) {
            const _this = this
            let vo = this.$refs.Basicform.vo
            // 是否立项，默认为否 0
            vo.isSet = 0
            // 设置状态为 0 未发送签收单
            vo.status = 0
            if (Date.parse(vo.overDate.substring(0, 10) + ' 23:59:59') <= Date.parse(vo.startDate.substring(0, 10) + ' 00:00:00')) {
                this.$alert('完成时限不能小于开始日期', '操作提示', { type: 'warning' })
                return
            }

            if (vo.phDept) {
                let key = false
                key = vo.phDept.split('、').some(function (item) {
                    return vo.qtDept.split('、').includes(item)
                })

                if (key) {
                    this.$alert('主办部门与配合部门不能重复', '操作提示', { type: 'warning' })

                    return
                }
            }
            //vo.passenger.attachments= []
            if (vo.passenger.attachments && vo.passenger.attachments.length) {
                vo.passenger.attachments.forEach((item) => {
                    if (item.uploadTime) {
                        item.uploadTime = null
                    }
                    item.noUpload = true
                })
                vo.passenger.noUpload = true
            }

            this.$http({
                url: 'dcdb/task/insert',
                method: 'POST',
                data: vo
            }).then((res) => {
                if (res.code === 'success') {
                    if (val === 'go') {
                        setTimeout(() => {
                            _this.dialogFormVisible = true
                            let indexs = null
                            _this.listdata.some((item, index) => {
                                if (item.id === this.row.id) {
                                    if (index < this.listdata.length - 1) {
                                        // this.choose(this.listdata[index + 1])
                                        indexs = index
                                    } else {
                                        this.$message({
                                            type: 'warning',
                                            message: '已经是最后一条数据了'
                                        })
                                        _this.showBasicForm = false
                                    }
                                    return true // 中断循环
                                }
                                return false // 继续循环
                            })

                            if (indexs !== null) {
                                _this.moduleInfo.row = _this.listdata[indexs + 1]
                                _this.row = _this.listdata[indexs + 1]
                                _this.moduleInfo.formTemplate = `#/dcontent/vuebusiform/W/dcdb.task.form_toChange.vue?sysCode=${_this.row.orgCode}_ecydcdb`
                                _this.title = '转督办任务'
                                _this.$options.components['BusiForm'] = _this.$loadComponent(_this.moduleInfo.formTemplate)
                                _this.dialogFormVisible = true
                                _this.$nextTick(() => {
                                    _this.$bus.emit('openBusiform', _this.moduleInfo, null, 1, (res) => {
                                        if (res.code === 'success') {
                                            this.$message({ type: 'success', message: '保存成功!' })
                                        }
                                    })
                                })
                            }
                        }, 500)
                    } else {
                        _this.showBasicForm = false
                        _this.$message({ type: 'success', message: '保存成功!' })
                    }
                }
            })
        },
        submitBusiform() {
            const _this = this
            this.submit('go')
        },
        open(data) {
            this.listdata = data
            this.$nextTick(() => {
                this.dialogFormVisible = true
            })
        },
        closeE() {
            this.listdata = []
            this.dialogFormVisible = false
            this.$nextTick(() => {
                this.$vnode.context.taskDiaShow = false
            })
        },
        dcdbStatusOption(val) {
            if (val === 0) {
                return '未交办'
            }
            if (val === 1) {
                return '已转任务'
            }
            if (val === 2) {
                return '已交办'
            }
        }
    }
}
</script>

<style scoped lang="scss"></style>
